import classNames from "classnames";
import './index.less';

const StructuredList = ({ children, className, ...props }) => {
    return (
        <div className={classNames("structured-list", className)} {...props}>
            {children}
        </div>
    )
}

StructuredList.Item = ({ children, className, ...props }) => {
    return (
        <div className={classNames("structured-list-item", className)} {...props}>
            {children}
        </div>
    )
}

export default StructuredList;